class NavBarService {
    public isOpen = false;

    public open() {
        this.isOpen = true;
    }

    public close() {
        this.isOpen = false;
    }

    public change() {
        this.isOpen = !this.isOpen;
    }
}

export default new NavBarService();
